export default __webpack_public_path__ + "search-fbed9bc9a06e9d8ae9b08f668d2142ab.svg";